import chatbotRequest from '@/service/channel/http'
import type { BroadcastUserListReq, BroadcastUserListRes } from '../types/getBroadcastUserList'

export function getBroadcastUserListApi(data: BroadcastUserListReq): Promise<BroadcastUserListRes> {
    return chatbotRequest<BroadcastUserListRes, BroadcastUserListReq, BroadcastUserListRes>({
        url: '/api/broadcast/telegram/user/list',
        method: 'post',
        data,
    })
}